import { ConfirmationDialogV2 } from '@/components/custom/erp/confirmation-dialog-v2';

interface DeleteDialogV2Props {
  open: boolean;
  onClose: () => void;
  selectedObj?: any;
  deleteObj?: (uuid: string, obj?: any) => Promise<unknown> | unknown;
  deleteDoiTuong?: (uuid: string, obj?: any) => Promise<unknown> | unknown;
  clearSelection?: () => void;
  title?: string;
  message?: string;
}

export function DeleteDialogV2({
  open,
  onClose,
  selectedObj,
  deleteObj,
  deleteDoiTuong,
  clearSelection,
  title = 'Xóa dữ liệu',
  message = 'Bạn có chắc chắn muốn xóa dữ liệu này không?'
}: DeleteDialogV2Props) {
  const handleConfirm = async () => {
    if (selectedObj?.uuid) {
      await (deleteObj || deleteDoiTuong)?.(selectedObj.uuid, selectedObj);
    }
    clearSelection?.();
    onClose();
  };

  return (
    <ConfirmationDialogV2 open={open} title={title} message={message} onClose={onClose} onConfirm={handleConfirm} />
  );
}

export default DeleteDialogV2;
